export const models = {
  name: null,
  email: null,
  password: null,
  phone_number: null,
  phone: null,
  password_confirmation: null
};
export const options = {};

export const Fields = [
  {
    label: "Name",
    name: "name",
    placeholder: "Enter the name",
    type: "text",
    value: "",
    rules: "required",
    validationMessage: {
      required: "This field is required"
    },
    xl: "12"
  },
  {
    label: "Email",
    name: "email",
    placeholder: "Enter the email",
    type: "email",
    value: "",
    xl: "12"
  },
  {
    label: "Phone",
    name: "phone_number",
    placeholder: "Enter the Phone number",
    type: "phone",
    value: "",
    rules: "required",
    validationMessage: {
      required: "This field is required"
    },
    xl: "12"
  },
  {
    label: "Password",
    name: "password",
    placeholder: "Enter the password",
    type: "password",
    value: "",
    xl: "12"
  }
];
